import { useQueryParams, BooleanParam } from 'use-query-params'
import { numberQueryParamEncoder } from 'utils/query-params/number.utils'
import {
  stringQueryParamEncoder,
  makeGenericStringQueryParamEncoder,
} from 'utils/query-params/string.utils'
import { type CatalogSearchType } from 'legacy/sections/catalog/components/search/utils/catalogSearch.constants'

// Still used for Aisles > Add Products
export const useCatalogSearchQueryParamsBehaviour = () => {
  const [queryParams, setQueryParams] = useQueryParams({
    departmentId: numberQueryParamEncoder,
    aisleId: numberQueryParamEncoder,
    available: BooleanParam,
    hasImage: BooleanParam,
    searchTerm: stringQueryParamEncoder,
    searchType: makeGenericStringQueryParamEncoder<CatalogSearchType>(),
    locale: stringQueryParamEncoder,
  })

  return {
    queryParams,
    setQueryParams,
  }
}
